import { useState } from "react";
import { toast } from "sonner";
import { Monitor, Printer, Layers, AlertTriangle } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";

const opts = [["screen", Monitor], ["print", Printer], ["both", Layers]];

export function OrdersDeliveryBanner({ dark = false, hasTicketPrinter = true }) {
  const { restaurant, setRestaurant, user } = useAuth();
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  const cur = restaurant.orders_delivery || "screen";
  const isOwner = user.role === "owner";
  const set = async (v) => {
    if (!isOwner || v === cur) return;
    setBusy(true);
    try { await api.patch(`/restaurants/${restaurant.id}/orders-delivery`, { orders_delivery: v }); setRestaurant({ ...restaurant, orders_delivery: v }); toast.success(t("saved")); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  const base = dark ? "border-slate-700 bg-slate-900/70 text-slate-100" : "border-slate-200 bg-white";
  return (
    <div data-testid="orders-delivery-banner" className={`rounded-2xl border p-4 ${base}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-heading font-bold">{t("orders_delivery")}</p>
          <p className={`text-xs ${dark ? "text-slate-400" : "text-slate-500"}`}>{t("orders_delivery_desc")}</p>
        </div>
        <div className={`flex gap-1 rounded-full p-1 ${dark ? "bg-slate-800" : "bg-slate-100"}`}>
          {opts.map(([v, I]) => <button key={v} type="button" data-testid={`delivery-${v}`} disabled={busy || !isOwner} onClick={() => set(v)} className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${cur === v ? "bg-[#5aa469] text-white" : dark ? "text-slate-300 hover:bg-slate-700" : "text-slate-600 hover:bg-white"}`}><I size={14} />{t(`delivery_${v}`)}</button>)}
        </div>
      </div>
      {cur !== "screen" && !hasTicketPrinter && <p data-testid="delivery-no-printer-warn" className="mt-2 flex items-center gap-1.5 text-xs font-semibold text-amber-500"><AlertTriangle size={14} />{t("delivery_no_printer")}</p>}
      {cur === "print" && <p data-testid="delivery-print-only-note" className={`mt-2 text-xs ${dark ? "text-slate-400" : "text-slate-500"}`}>{t("delivery_print_only_note")}</p>}
    </div>
  );
}
